let defaultLoginInfo = {};
try {
  if (JSON.parse(localStorage.accountInfo)) {
    defaultLoginInfo = JSON.parse(localStorage.accountInfo);
  }
} catch (e) {}

let defaultUserInfo = {};
try {
  if (JSON.parse(localStorage.getItem("USER_INFO"))) {
    defaultUserInfo = JSON.parse(localStorage.getItem("USER_INFO"));
  }
} catch (e) {}

export default {
  loginInfo: defaultLoginInfo,
  paypalConfirmed: false, //paypal账号是否确认（提交后即确认，不允许修改）
  userInfo: defaultUserInfo,
  cookieNoticeShow: false, //
  iPShow:false,
  ipCN:false
};



// WEBPACK FOOTER //
// ./src/store/state.js